import {
  DANGEROUS_CONFIG_RECEIVE,
  INFO_PAGES_RECEIVE,
} from '../../../globals/actions';
import {
  DangerousConfigReceive,
  InfoPagesReceive,
} from '../../../globals/actions/types';
import { FooterState, FooterActionTypes } from './types';

const initialState: FooterState = {
  socialNetworks: [],
  current: '',
  sites: [],
  pages: {
    nodes: [],
    open: () => {},
  },
  url: {},
  open: () => {},
};

export default function reducer(
  state = initialState,
  action: FooterActionTypes
): FooterState {
  if (!state) {
    return {
      ...initialState,
      current: '',
    };
  }

  switch (action.type) {
    /**
      NOTE: All config is dispatch, any data returned will be sent
      down to the browser. Make sure no secrets is leaking!
    * */
    case DANGEROUS_CONFIG_RECEIVE: {
      const { market, markets, server } = action as DangerousConfigReceive;
      return {
        ...state,
        current: market.countryCode,
        sites: Object.keys(markets)
          .filter(code =>
            server.appEnv === 'production' ? markets[code].active : true
          )
          .map(code => ({
            url: markets[code].sites[server.appEnv],
            code,
          })),
        socialNetworks: Object.keys(market.socialNetworks || {}).map(name => ({
          name,
          link: market.socialNetworks[name].link,
        })),
        url: {
          campaigns:
            market.url && market.url.campaigns
              ? market.url.campaigns
              : undefined,
        },
      } as FooterState;
    }
    case INFO_PAGES_RECEIVE: {
      return {
        ...state,
        pages: (action as InfoPagesReceive).pages,
      };
    }
    default:
  }

  return state;
}
